<template>
  <div class="bg-truegray-700 min-h-screen w-full">
    <!-- Content -->
    <div class="lg:h-72 flex justify-start items-end p-12 bg-gray-200">
      <div
        class="h-32 border-l-4 pl-6 border-black flex flex-col justify-end items-end m-0 p-0 w-full"
      >
        <h1 class="w-full text-left">Analytics</h1>
        <span class="text-md w-full text-left">Track your user activity</span>
      </div>
    </div>

    <div
      :class="[iframes_loaded ? '' : 'bg-truegray-500']"
      class="w-full px-8 py-16 lg:p-16"
    >
      <div
        v-if="!iframes_loaded"
        class="h-72 flex flex-col justify-center items-center"
      >
        <lottie :options="loadingAnimationOptions" />
        <span class="text-white text-center">Loading Analytics</span>
      </div>

      <div v-if="loaded" class="w-full bg-white rounded-xl">
        <div
          v-show="iframes_loaded"
          id="analytics_top"
          class="w-full flex p-16"
        >
          <div class="w-full lg:w-1/3 lg:pr-4 border-truegray-300 border-r">
            <div class="border-truegray-300 border-b pb-6">
              <h2 class="mb-0">Reports : {{ active_date_range.text }}</h2>
              <div class="flex space-x-4 mt-4">
                <InputDropdown
                  :selected-options-initial="[date_range_selected]"
                  :options="date_range_options"
                  :margin-bottom="false"
                  :border-enabled="true"
                  :response-selection-id="'new_date_range'"
                />
                <button
                  class="btn btn-primary flex-shrink-0 m-0"
                  @click="reloadIframes"
                >
                  Run Report
                </button>
              </div>
            </div>

            <div class="w-full pt-6">
              <div
                class="px-6 py-3 mb-2 items-center justify-between flex flex-wrap cursor-pointer transition-all duration-300 ease-in-out rounded border border-truegray-300 hover:border-black"
                :class="
                  active_report === 1 ? 'text-white bg-black border-black' : ''
                "
                @click="reportRequest(1)"
              >
                <h5 class="font-primary mb-0">Site Visits</h5>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div
                :class="
                  active_report === 1
                    ? 'h-auto transition-all duration-300 ease-in-out'
                    : 'h-0 opacity-0 pointer-events-none'
                "
              >
                <iframe
                  width="100%"
                  height="500"
                  :src="
                    'https://analyticsdj.com/index.php?forceView=1&viewDataTable=sparklines&module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=VisitsSummary&actionToWidgetize=get&idSite=' +
                    site_id +
                    '&period=range&date=' +
                    active_date_range.date +
                    ',' +
                    today.date +
                    '&token_auth=' +
                    view_auth_token
                  "
                  scrolling="yes"
                  frameborder="0"
                  marginheight="0"
                  marginwidth="0"
                  @load="checkIframeLoadStatus(0)"
                ></iframe>
              </div>
            </div>

            <div class="w-full pt-2">
              <div
                class="px-6 py-3 mb-2 items-center justify-between flex flex-wrap cursor-pointer transition-all duration-300 ease-in-out rounded border border-truegray-300 hover:border-black"
                :class="
                  active_report === 2 ? 'text-white bg-black border-black' : ''
                "
                @click="reportRequest(2)"
              >
                <h5 class="font-primary mb-0">Page Hits</h5>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div class="w-full lg:w-2/3 p-4">
            <div v-show="active_report === 1" class="w-full">
              <iframe
                width="100%"
                height="500"
                :src="
                  'https://analyticsdj.com/index.php?forceView=1&viewDataTable=graphEvolution&module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=VisitsSummary&actionToWidgetize=getEvolutionGraph&idSite=' +
                  site_id +
                  '&period=range&date=' +
                  active_date_range.date +
                  ',' +
                  today.date +
                  '&token_auth=' +
                  view_auth_token
                "
                scrolling="yes"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                @load="checkIframeLoadStatus(1)"
              ></iframe>
            </div>
            <div v-show="active_report === 2" class="w-full">
              <iframe
                width="100%"
                height="725"
                :src="
                  'https://analyticsdj.com/index.php?module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=Actions&actionToWidgetize=getPageTitles&idSite=' +
                  site_id +
                  '&period=range&date=' +
                  active_date_range.date +
                  ',' +
                  today.date +
                  '&token_auth=' +
                  view_auth_token
                "
                scrolling="yes"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                @load="checkIframeLoadStatus(2)"
              ></iframe>
            </div>
          </div>
        </div>

        <div v-if="request_failure" class="w-full text-red-400">
          We were unable to fetch your analytics. Refresh to try again, or
          contact the Career Wise team for assistance.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../../js/mixins/shared.js'
import { EventBus } from '../../../../js/plugins/event-bus.js'
import InputDropdown from '../../../../shared/components/InputDropdown.vue'
import * as loadingAnimation from '../../../../shared/components/loading.json'

export default {
  components: { InputDropdown },
  mixins: [shared],

  data() {
    return {
      loaded: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
      admin_auth_token: '',
      view_auth_token: '',
      site_id: null,
      request_failure: false,
      loaded_iframes: [],
      iframe_total: 3,
      iframes_loaded: false,

      today: {},
      // sevendays : {},
      // thirtydays : {},
      // threemo : {},
      // oneyear : {},

      active_report: 1,
      active_date_range: {},

      date_range_options: [],

      date_range_selected: 0,
    }
  },

  mounted() {
    let id = document.getElementsByTagName('body')[0].dataset.matomo_tracking
    if (id) {
      this.$set(this, 'site_id', id)
      axios.get('/api/auth/analytics/' + id).then((response) => {
        let data = response.data
        if (data.success) {
          this.$set(this, 'date_range_options', [])
          this.$set(this, 'admin_auth_token', data.admin_token)
          this.$set(this, 'view_auth_token', data.view_token)

          this.$set(this, 'today', data.today)
          this.date_range_options.push(data.sevendays)
          this.date_range_options.push(data.thirtydays)
          this.date_range_options.push(data.threemo)
          this.date_range_options.push(data.oneyear)

          this.$set(this, 'active_date_range', data.sevendays)

          this.$set(this, 'loaded', true)
        } else {
          this.$set(this, 'loaded', true)
          this.$set(this, 'request_failure', true)
        }
      })
    } else {
      EventBus.$emit('triggerAlertResponse', {
        status: 'error',
        message: 'Analytics not set up. Contact The CareerWise team',
      })
      this.$router.push({ path: '/' })
    }

    EventBus.$on('new_date_range', (selected) => {
      this.$set(this, 'date_range_selected', selected)
    })
  },

  methods: {
    checkIframeLoadStatus(id) {
      if (!this.loaded_iframes.includes(id)) {
        this.loaded_iframes.push(id)
      }
      if (this.loaded_iframes.length === this.iframe_total) {
        this.$set(this, 'iframes_loaded', true)
      }
    },

    reportRequest(id) {
      this.$set(this, 'active_report', id)
      if (id === 2) {
        this.scrollTo('#analytics_top')
      }
    },

    // Destroy the iframes, call in the newly selected date range and reload the iframes
    reloadIframes() {
      this.$set(this, 'loaded', false)
      this.$set(this, 'loaded_iframes', [])
      this.$set(this, 'iframes_loaded', false)
      this.date_range_options.forEach((option) => {
        if (this.date_range_selected === option.value) {
          this.$set(this, 'active_date_range', option)
        }
      })
      setTimeout(() => {
        this.$set(this, 'loaded', true)
      }, 500)
    },
  },
}
</script>

<style scoped>
.post-intro::after {
  content: '';
  background: #fff;
  height: 1px;
  width: 500px;
  min-width: 95%;
  position: absolute;
  top: 4rem;
  right: 0;
}

@media screen and (max-width: 1024px) {
  .post-intro::after {
    display: none;
  }
}
</style>
